import React from "react";
import Card from "@/home_components/card";

const createAhorroLabel = (cardData) => {
  const res = cardData;
  const { originalPrice, monthlyPayment, alternativeMonthlyPayment } = cardData;
  const requireAlternative = ( cardData?.["Price-2"]?.amount < 0 &&  cardData?.["Price-2"]?.alternativeAmount &&  alternativeMonthlyPayment) ? true : false;
  let r2rPrice = requireAlternative ? cardData["Price-2"]?.alternativeAmount : cardData["Price-2"]?.amount;
  const r2rMonthlyPayment = requireAlternative ? alternativeMonthlyPayment : monthlyPayment;
  r2rPrice = r2rPrice.toString().replace(',', '.');

  if (r2rPrice && parseFloat(r2rPrice) >= 0 && originalPrice && r2rMonthlyPayment) {
    const ahorro = -(
      parseFloat(r2rMonthlyPayment) * parseFloat(r2rPrice) -
      parseFloat(originalPrice)
    );
    if (ahorro > 10) {
      const normalizedSavingForLabel = Math.round(ahorro);
      res["Label-2"] = {
        text: `Ahorro ${normalizedSavingForLabel}€`,
        type: "promocion",
        inversed: false,
        notBorderRadius: true,
      };
    }
  }
  return res;
};

const DevicesOffers = ({ cardData, taggingInfo }) => {
  const labelAhorro = createAhorroLabel(cardData);
  const { custoStamps } = cardData;

  const alternative = ( cardData?.["Price-2"]?.amount < 0 &&  cardData?.["Price-2"]?.alternativeAmount &&  cardData?.alternativeMonthlyPayment) ? true : false;
  
  if(alternative) {
    cardData["Price-2"].amount = cardData["Price-2"].alternativeAmount;
  }
  
  return (
    <>
      <div className="featured-dispo-card">
        <Card
          taggingInfo={taggingInfo}
          {...{ ...cardData, ...labelAhorro, custoStamps: custoStamps }}
          imageClassName="aspect-ratio-4-5"
          sizes="200px"
        ></Card>
      </div>

      <style jsx>
        {`.featured-dispo-card {
  height: 100%;
}
.featured-dispo-card :global(.card-column) {
  min-height: 200px;
  width: 11.9rem;
}
.featured-dispo-card :global(.card) {
  padding: 1rem;
}
.featured-dispo-card :global(.card-clickable) {
  height: 100%;
  align-items: flex-end;
}
.featured-dispo-card :global(.card-container) {
  gap: 0.7rem;
  align-items: flex-end;
  flex-flow: column nowrap;
  flex: 1;
  height: 100%;
}
.featured-dispo-card :global(.card-container) :global(.card-container--info) {
  justify-content: flex-end;
}
.featured-dispo-card :global(.card-container) :global(.label) {
  padding: 0.25rem 0.5rem;
}
.featured-dispo-card :global(.card-container) :global(.card-container--image--stamp) {
  height: 11.2rem;
  gap: 0.1rem;
}
.featured-dispo-card :global(.card-container) :global(.card-container--image) {
  max-width: 7rem;
  height: 100%;
}
.featured-dispo-card :global(.card-container) :global(.card-container--image.with-stamp) {
  height: 9rem;
}
.featured-dispo-card :global(.card-container) :global(.card-content--price) {
  line-height: 1.25rem;
  margin-top: 0.2rem;
}
.featured-dispo-card :global(.card-container) :global(.card-content--price) :global(.price) {
  display: inline-block;
  margin-right: 0.2rem;
}
.featured-dispo-card :global(.card-container) :global(.card-content--price) :global(.price--pre-price) {
  display: block;
}
.featured-dispo-card :global(.card-container) :global(.card-header) {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 3rem;
}
.featured-dispo-card :global(.card-container) :global(.card-header) :global(.card-header--title) {
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.featured-dispo-card :global(.card-container) :global(.card-container--info) {
  gap: 0.7rem;
  flex: 1;
}

@media screen and (min-width: 768px) {
  .featured-dispo-card :global(.card-column) {
    height: 100%;
    width: inherit;
  }
  .featured-dispo-card :global(.card-column) :global(.card-header--title) {
    line-height: 1.5rem;
  }
  .featured-dispo-card :global(.card-container) {
    flex-flow: row nowrap;
    align-items: flex-end;
    flex: inherit;
  }
  .featured-dispo-card :global(.card-container) :global(.card-container--info) {
    padding-bottom: 0.5rem;
  }
  .featured-dispo-card :global(.card-container) :global(.card-header) {
    min-height: inherit;
  }
  .featured-dispo-card :global(.card-container) :global(.card-header) :global(.text) {
    line-height: 1.5rem;
  }
  .featured-dispo-card :global(.card-container) :global(.card-content) {
    height: auto;
  }
}
@media screen and (min-width: 1280px) {
  .featured-dispo-card :global(.card-column) {
    min-width: 0;
    height: 100%;
  }
  .featured-dispo-card :global(.card) :global(.offer-progress) {
    display: block;
  }
  .featured-dispo-card :global(.card) :global(.offer-progress) :global(.offer--text) {
    display: flex;
    justify-content: space-between;
  }
  .featured-dispo-card :global(.card-container) :global(.card-container--label) {
    display: block;
    width: 100%;
  }
  .featured-dispo-card :global(.card-container) :global(.card-header) :global(.text) {
    line-height: 1.5rem;
  }
}`}
      </style>
    </>
  );
};

export default DevicesOffers;
